export enum EventType {
    SPORT = "S",
    CULTURE = "C",
    MULTI = "M"
}
